import React from "react";
import T from "prop-types";

import useServerMessage from "b2b/i18n/useServerMessage";

import ZadostiGroupTypZdroje from "./ZadostiGroupTypZdroje";

function ZadostiGroupsTypyZdroju({ data, loading, onChange, value }) {
  const getServerMessage = useServerMessage();
  return (
    <div className="b2b-ZadostiGroups-typyZdroju">
      {data.map(({ typZdroje, zdroje }) => {
        return (
          <ZadostiGroupTypZdroje
            key={`${typZdroje.name}`}
            label={getServerMessage(typZdroje, "vyznam")}
            list={zdroje}
            loading={loading}
            onChange={onChange}
            value={value}
          />
        );
      })}
    </div>
  );
}

ZadostiGroupsTypyZdroju.propTypes = {
  data: T.array.isRequired,
  loading: T.bool,
  onChange: T.func.isRequired,
  value: T.object
};

export default React.memo(ZadostiGroupsTypyZdroju);
